import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  scheduleEvents: [],
  scheduleEvent: null,
};

export const scheduleEventSlice = createSlice({
  name: "scheduleEvent",
  initialState,
  reducers: {
    setScheduleEvents: (state, { payload }) => {
      state.scheduleEvents = payload.scheduleEvents;
    },
    addScheduleEvent: (state, { payload }) => {
      state.scheduleEvents.unshift(payload.scheduleEvent);
    },
    deleteScheduleEvent: (state, { payload }) => {
      const { id: scheduleEventId } = payload.scheduleEvent;

      state.scheduleEvents = state.scheduleEvents.filter(
        (event) => event.id !== scheduleEventId
      );
    },
    setScheduleEvent(state, { payload }) {
      state.scheduleEvent = payload;
    },
    clearScheduleEvent(state) {
      state.scheduleEvent = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setScheduleEvents,
  addScheduleEvent,
  deleteScheduleEvent,
  setScheduleEvent,
  clearScheduleEvent,
} = scheduleEventSlice.actions;
